import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const T = {
  it: { over: "FAQ", title: "Domande frequenti.", sub: "Non trovi la risposta che cerchi? Scrivici tramite la pagina contatti — saremo felici di aiutarti." },
  en: { over: "FAQ", title: "Frequently asked questions.", sub: "Can't find what you're looking for? Write to us via the contact page — we'll be happy to help." },
};

export default function FAQPage() {
  const { lang } = useI18n();
  const c = T[lang];
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data || []));
  }, []);

  return (
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 lg:py-20" data-testid="faq-page">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-editorial text-muted-ink mb-3">{c.over}</div>
          <h1 className="font-display text-5xl md:text-6xl text-brand leading-tight">{c.title}</h1>
          <p className="mt-4 text-muted-ink">{c.sub}</p>
        </div>
        <div className="md:col-span-8">
          <Accordion type="single" collapsible className="border-t border-soft" data-testid="faq-accordion">
            {faqs.map((f) => {
              const q = lang === "en" && f.translations?.en?.question ? f.translations.en.question : f.question;
              const a = lang === "en" && f.translations?.en?.answer ? f.translations.en.answer : f.answer;
              return (
                <AccordionItem key={f.id} value={f.id} className="border-b border-soft">
                  <AccordionTrigger className="text-brand hover:no-underline text-left py-5">{q}</AccordionTrigger>
                  <AccordionContent className="text-muted-ink text-sm pb-5">{a}</AccordionContent>
                </AccordionItem>
              );
            })}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
